import React, { useEffect, useState } from "react";
import {
	Textfield,
	Button,
	Checkbox,
	LoadingComponent,
	RadioButtonList,
	Select,
	NetTable,
	Modal,
	NoDataFoundTemplate,
	MultiSelectTable,
} from "../../../components/core";
import { ContentContainer } from "../../../components/layout";
import { useQuery, useLazyQuery } from "@apollo/client";
import { NumericFormat } from "react-number-format";
import { Calendar } from "primereact/calendar";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import BroadcastUserAPI from "../../../features/broadcast-users/broadcast-users";
import {
	QUERYBroadcastList,
	queryUserLockerName,
	queryUserTypeId,
} from "../../../features/broadcast-users/gql";
import SendSMSModal from "./components/send-sms-modal";
import SendAppModal from "./components/send-app-modal";
import SendEmailModal from "./components/send-email-modal";
import { useSelector } from "react-redux";
import { Tag } from "primereact/tag";
import { Badge } from "primereact/badge";
import { InputText } from "primereact/inputtext";
const BroadcastUsers = () => {
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	const [userGender, setUserGender] = useState([]);
	const [selectedUserType, setSelectedUserType] = useState("");
	const [selectedLockerName, setSelectedLockerName] = useState("");
	const [broadcastUserType, setBroadcastUserType] = useState([]);
	const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
	const [noResultSearch, setNoResultSearch] = useState(false);
	const [userLockerName, setUserLockerName] = useState([]);
	const [checkNoAppYet, setCheckNoAppYet] = useState(false);
	const [checkWithAppYet, setCheckWithAppYet] = useState(false);
	const [checkAppAccess, setCheckAppAccess] = useState(false);
	const [userNumber, setUserNumber] = useState("");
	const [firstName, setFirstName] = useState("");
	const [surname, setSurname] = useState("");
	const [isoDate, setIsoDate] = useState("");
	const [searchResultHeader, setSearchResultHeader] = useState("");
	const [broadCastUsers, setBroadCastUsers] = useState([]);
	const [withAppNotif, setWithAppNotif] = useState(0);
	const [isLoading, setisLoading] = useState(false);
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	const broadCastUsersAPI = new BroadcastUserAPI();
	const [mobileNumbers, setmobileNumbers] = useState([]);
	const [emailsList, setemailsList] = useState([]);
	const [targetApp, settargetApp] = useState([]);

	const [checkedUsers, setcheckedUsers] = useState([]);

	const gender = [
		{ value: "0", name: "Unspecified" },
		{ value: "1", name: "Male" },
		{ value: "2", name: "Female" },
	];
	const status = [
		{ value: "0", name: "Not Verified" },
		{ value: "1", name: "Verified" },
		{ value: "2", name: "Pending Verification" },
		{ value: "3", name: "Rejected" },
	];

	const [sendSMSData, setSendSMSData] = React.useState({
		open: false,
		message: "",
		operatorId: localStorage.getItem("user")
			? JSON.parse(localStorage.getItem("user")).operator_id
			: "",
		target: [],
	});
	const [sendAppData, setSendAppData] = React.useState({
		open: false,
		operatorId: localStorage.getItem("user")
			? JSON.parse(localStorage.getItem("user")).operator_id
			: "",
		message: "",
		target: [],
		category: "-1",
		image: "",
		subject: "",
	});
	const [sendEmailData, setSendEmailData] = React.useState({
		open: false,
		operatorId: localStorage.getItem("user")
			? JSON.parse(localStorage.getItem("user")).operator_id
			: "",
		message: "",
		target: [],
		subject: "",
	});

	const buildVariables = () => {
		const updatedVariables = {
			operatorId: operatorId,
			// noAppYet: checkAppAccess,
		};

		// console.log({ updatedVariables })
		if (userNumber.trim() !== "") {
			updatedVariables.userMobile = userNumber;
		}

		if (firstName.trim() !== "") {
			updatedVariables.firstName = firstName;
		}

		if (checkAppAccess !== "") {
			updatedVariables.noAppYet = checkAppAccess;
		}

		if (userNumber.trim() !== "") {
			updatedVariables.userMobile = userNumber;
		}

		if (surname.trim() !== "") {
			updatedVariables.lastName = surname;
		}

		if (isoDate !== "") {
			updatedVariables.lastLockerDate = new Date(isoDate)
				.toISOString()
				.toString()
				.split("T")[0];
		}

		if (userGender.length != 0) {
			updatedVariables.gender = userGender;
		}

		if (selectedUserType.trim() !== "") {
			updatedVariables.userTypeId = parseInt(selectedUserType);
		}

		if (selectedLockerName.trim() !== "") {
			updatedVariables.lastLockerId = parseInt(selectedLockerName);
		}
		return updatedVariables;
	};

	const [BroadcastUserList, { data, loading }] = useLazyQuery(
		QUERYBroadcastList,
		{ fetchPolicy: "no-cache" }
	);

	// console.log({ data })
	const userTypes = useQuery(queryUserTypeId, {
		variables: { operatorId: operatorId },
	});
	const lockerName = useQuery(queryUserLockerName, {
		variables: { operatorId: operatorId },
	});
	useEffect(() => {
		if (userTypes.data) {
			let tempData = [{ value: "", name: "All User Types" }];
			userTypes.data.lockerUserTypes.forEach((element, index) => {
				tempData.push({
					value: element.userTypeId,
					name: element.userType,
				});
			});
			// console.log(tempData);
			setBroadcastUserType(tempData);
		}
	}, [userTypes.data]);

	useEffect(() => {
		if (lockerName.data) {
			let tempData2 = [{ value: "", name: "All Lockers" }];
			lockerName.data.lockers.forEach((element, index) => {
				tempData2.push({
					value: element.lockerId,
					name: element.lockerName,
				});
			});
			// console.log(tempData2);

			setUserLockerName(tempData2);
		}
	}, [lockerName.data]);

	useEffect(() => {
		if (data) {
			if (data.userAccountsMessageBroadcastList.length == 0) {
				setisLoading(false);
				setNoResultSearch(true);
				return;
			}
			setNoResultSearch(false);
			let tempData = [...data.userAccountsMessageBroadcastList];
			let tempArr = [];
			let tempArr3 = [];
			let tempArr5 = [];
			data.userAccountsMessageBroadcastList.forEach((element, index) => {
				let obj = { ...element };

				obj.gender = gender.find(
					(x) => x.value === element.gender.toString()
				).name;
				obj.status = status.find(
					(x) =>
						x.value ===
						(element.status == null ? "" : element.status).toString()
				).name;

				obj.lockerId =
					element.lockerId == null
						? ""
						: userLockerName.find(
								(x) =>
									x.value ===
									(element.lockerId == null ? "" : element.lockerId).toString()
						  ).name;
				obj.mobile = element.mobile.toString().substring(2);
				obj.name = element.name == ",  " ? "-" : element.name;

				obj.birthDate = obj.birthDate ? formatBirthdate(obj.birthDate) : "";
				obj.regDate = obj.regDate ? formatBirthdate(obj.regDate) : "";
				tempData[index] = obj;
			});
			setBroadCastUsers(tempData);
			setisLoading(false);
		}
	}, [data]);

	console.log({ broadCastUsers });
	const handleSearch = (e) => {
		const variable = buildVariables();
		handleSearchResultHeader();
		setBroadCastUsers([]);
		setmobileNumbers([]);
		setemailsList([]);
		settargetApp([]);
		setcheckedUsers([]);
		setisLoading(true);

		BroadcastUserList({
			variables: variable,
		}).catch((e) => {
			setisLoading(false);
			setNoResultSearch(true);
		});
	};

	function handleSearchResultHeader() {
		setSearchResultHeader(`
      ${userNumber == "" ? "" : `${userNumber}, `}
      ${firstName == "" && surname == "" ? "" : `${firstName} ${surname} in `} 

      ${
				userGender.length == 0 || userGender.length == 3
					? "All Genders,"
					: `${
							userGender.length == 1
								? `${
										gender.find((item) => item.value == userGender).name
								  } Gender,`
								: `${userGender.map(
										(e, i) => gender.find((item) => item.value == e).name
								  )} Genders`
					  }`
			}

      ${
				(checkNoAppYet && checkWithAppYet) ||
				(!checkNoAppYet && !checkWithAppYet)
					? "With or Without MBOX User App"
					: checkNoAppYet
					? "Without MBOX User App"
					: "With MBOX User App"
			}
        ,
		${
			selectedUserType == ""
				? "Any User Type"
				: `${
						broadcastUserType.find((item) => item.value == selectedUserType)
							.name
				  } User Type`
		}
      in
	${
		selectedLockerName == ""
			? "All Lockers"
			: `${
					userLockerName.find((item) => item.value == selectedLockerName).name
			  }`
	} 
      ${
				isoDate == ""
					? ""
					: `who used the locker on or after ${formatDate(isoDate)}`
			}
`);
	}

	// const handleImageChange = (event) => {
	// 	const file = event.target.files[0];

	// 	if (file) {
	// 		const reader = new FileReader();

	// 		reader.onloadend = () => {
	// 			// The result property contains the base64-encoded image
	// 			const base64String = reader.result;
	// 			setAppMessageImage(base64String);
	// 		};

	// 		// Read the image as a data URL
	// 		reader.readAsDataURL(file);
	// 	}
	// };

	useEffect(() => {
		if (checkNoAppYet && !checkWithAppYet) {
			setCheckAppAccess(true);
		} else if (!checkNoAppYet && checkWithAppYet) {
			setCheckAppAccess(false);
		} else {
			setCheckAppAccess(null);
		}
	}, [checkNoAppYet, checkWithAppYet]);

	return (
		<ContentContainer containerTitle={"Broadcast Users"}>
			<div className="Upper-Form">
				<div className={"grid grid-cols-4 w-9/12 pb-2"}>
					<p1 className="my-auto">Name:</p1>
					<Textfield
						placeholder={"Surname"}
						className={"w-52 mr-2"}
						onChange={(event) => setSurname(event.target.value)}
						value={surname}
					/>
					<Textfield
						placeholder={"First name"}
						className={"w-52"}
						onChange={(event) => setFirstName(event.target.value)}
						value={firstName}
					/>
				</div>
				<div className={"grid grid-cols-2 w-9/12 pb-2"}>
					<p1 className="my-auto">Registered mobile number:</p1>
					<div className="flex flex-row items-center">
						<p1 className="pr-1"> +63 </p1>
						{/* <NumericFormat
							placeholder={"9XXXXXXXXX"}
							className={"w-52"}
							value={userNumber}
							onChange={(event) => setUserNumber(event.target.value)}
							customInput={Textfield}
						/> */}
						<InputText
							keyfilter={"int"}
							maxLength={10}
							placeholder={"9XXXXXXXXX"}
							className={
								"my-auto h-10 border-2 focus:outline-yellow-400 rounded-md p-1"
							}
							value={userNumber}
							onChange={(event) => setUserNumber(event.target.value)}
						/>
					</div>
				</div>
				<div>
					<p1 className={"grid grid-cols-6 mb-2"}>
						<p className="my-auto">Gender:</p>
						<Checkbox
							label="Unspecified"
							checked={userGender.indexOf(0) != -1}
							onChange={(clicked) => {
								var tempArr = [...userGender];
								if (clicked.target.checked) {
									setUserGender([...tempArr, 0]);
								} else {
									tempArr.splice(tempArr.indexOf(0), 1);
									setUserGender(tempArr);
								}
							}}
						/>
						<Checkbox
							label="Male"
							checked={userGender.indexOf(1) != -1}
							onChange={(clicked) => {
								var tempArr = [...userGender];
								if (clicked.target.checked) {
									setUserGender([...tempArr, 1]);
								} else {
									tempArr.splice(tempArr.indexOf(1), 1);
									setUserGender(tempArr);
								}
							}}
						/>
						<Checkbox
							label="Female"
							checked={userGender.indexOf(2) != -1}
							onChange={(clicked) => {
								var tempArr = [...userGender];
								if (clicked.target.checked) {
									setUserGender([...tempArr, 2]);
								} else {
									tempArr.splice(tempArr.indexOf(2), 1);
									setUserGender(tempArr);
								}
							}}
						/>
					</p1>
					{/* <p1>Search by Age: </p1> */}
					<div className="flex flex-row mb-3">
						<Checkbox
							label="With MBOX User APP"
							value={checkWithAppYet}
							checked={checkWithAppYet}
							onChange={(event) => {
								setCheckWithAppYet(event.target.checked);
							}}
							// onClick={() => {
							// 	setCheckAppAccess(true)
							// }}
						/>
						<div className="mr-5"></div>
						<Checkbox
							label="Without MBOX User APP"
							checked={checkNoAppYet}
							value={checkNoAppYet}
							onChange={(event) => {
								setCheckNoAppYet(event.target.checked);
							}}
							// onClick={() => {
							// 	setCheckAppAccess(false)
							// }}
						/>
					</div>
					{/* comment out since no functionality yet */}
					{/* <div className="flex flex-row mb-5">
						<div className="flex flex-wrap gap-3">
							<p className="my-auto">Courier App Notification Enabled?</p>
							<RadioButtonList
								dataItems={[
									{ id: 1, text: "Yes" },
									{ id: 2, text: "No" },
									{ id: 0, text: "Any" },
								]}
								handleChange={setWithAppNotif}
								initialID={0}
								disabled={true}
							/>
						</div>
					</div> */}
					<div className={"grid grid-cols-2 gap-y-2 w-1/2"}>
						<p1> User type:</p1>
						<Select
							className={"w-52"}
							items={broadcastUserType}
							onChange={(event) => {
								setSelectedUserType(event.target.value);
							}}
							value={selectedUserType}
						/>
						<p1>Used Locker On or After:</p1>
						<Calendar
							value={isoDate}
							todayButtonClassName="w-full"
							clearButtonClassName="w-full"
							onChange={(e) => setIsoDate(e.value)}
							dateFormat="mm/dd/yy"
							placeholder="mm / dd / yyyy"
							className="w-4/5 h-10 border-2 focus:outline-yellow-400 rounded-md p-1"
							readOnlyInput={true}
						/>
						<p1>Locker Name:</p1>
						<Select
							className={"w-52"}
							items={userLockerName}
							onChange={(event) => {
								setSelectedLockerName(event.target.value);
							}}
							value={selectedLockerName}
						/>
						<p1>Region:</p1>
						<Select
							className={"w-52"}
							items={[
								{
									value: "selectRegion",
									name: "Select Region",
								},
							]}
							disable={true}
						/>
					</div>
					<div className="grid grid-cols-2 w-1/2 gap-y-2 mt-2">
						<div></div>
						<u
							className="flex hover:text-blue-500 cursor-pointer ml-auto w-min"
							onClick={() => {
								setSelectedLockerName("");
								setSelectedUserType("");
								setSelectedLockerName("");
								setWithAppNotif(0);
								setCheckWithAppYet(false);
								setCheckNoAppYet(false);
								setUserGender([]);
								setUserNumber("");
								setFirstName("");
								setSurname("");
								setIsoDate("");
							}}
						>
							<i className="fas fa-undo my-auto"></i>
							<p className="ml-1">Reset</p>
						</u>
					</div>
					<Button
						value={"Search"}
						className={"w-40 h-8 mb-2"}
						onClick={handleSearch}
					/>
				</div>
				{isLoading && <LoadingComponent />}
				{broadCastUsers.length > 0 && (
					// <TableWithHeader
					// 	title={`Broadcase Users ${ searchResultHeader } `}
					// 	header={[
					// 		{
					// 			header_name: "Full Name",
					// 			key: "name",
					// 			date: false,
					// 		},
					// 		{
					// 			header_name: "Gender",
					// 			key: "gender",
					// 			date: false,
					// 		},
					// 		{
					// 			header_name: "Birth Date",
					// 			key: "birthDate",
					// 			date: true,

					// 		},
					// 		{
					// 			header_name: "Mobile",
					// 			key: "mobile",
					// 			date: false,
					// 		},
					// 		{
					// 			header_name: "Email",
					// 			key: "email",
					// 			date: false,
					// 		},
					// 		{
					// 			header_name: "Verification Status",
					// 			key: "status",
					// 			date: false,
					// 		},
					// 		{
					// 			header_name: "App Registration Date",
					// 			key: "regDate",
					// 			date: true,
					// 		},
					// 		{
					// 			header_name: "User Type",
					// 			key: "userType",
					// 			date: false,
					// 		},
					// 		{
					// 			header_name: "Locker",
					// 			key: "lockerId",
					// 			date: false,
					// 		},
					// 	]}
					// 	item={broadCastUsers}
					// />
					<>
						<div className="flex flex-row gap-1 mt-4">
							<p>Total: </p>
							<p className="font-bold">{broadCastUsers.length}</p>
						</div>
						<div id="Unrecognized Waybills Report">
							<div className={"grid grid-row-3 bg-yellow-400 p-2"}>
								<div className={"text-center"}>
									<span>
										<h1 className={"font-bold"}>Broadcast Users</h1>
									</span>
									<span>
										<h1
											className={"font-bold"}
										>{`For ${searchResultHeader} `}</h1>
									</span>
								</div>
							</div>
						</div>
						{/* <NetTable
							setSms={setmobileNumbers}
							setApp={settargetApp}
							setEmail={setemailsList}
							selectedProducts={checkedUsers}
							setSelectedProducts={setcheckedUsers}
							className={"text-xs"}
							showHeader={false}
							header={[
								{
									header_name: "Full Name",
									key: "name",
									date: false,
								},
								{
									header_name: "Gender",
									key: "gender",
									date: false,
								},
								{
									header_name: "Birth Date",
									key: "birthDate",
									date: true,
								},
								{
									header_name: "Mobile",
									key: "mobile",
									date: false,
								},
								{
									header_name: "Email",
									key: "email",
									date: false,
								},
								{
									header_name: "Verification Status",
									key: "status",
									date: false,
								},
								{
									header_name: "App Registration Date",
									key: "regDate",
									date: true,
								},
								{
									header_name: "User Type",
									key: "userType",
									date: false,
								},
								{
									header_name: "Locker",
									key: "lockerId",
									date: false,
								},
							]}
							item={broadCastUsers}
						/> */}

						<MultiSelectTable
							id={"broadcast-users-table"}
							items={broadCastUsers}
							keyToSelect="userAccountId"
							headers={{
								status: "Verification Status",
								name: "Full Name",
								gender: "Gender",
								birthDate: "Birth Date",
								mobile: "Mobile Number",
								email: "Email",
								regDate: "App Registration Date",
								userType: "User Type",
								lockerId: "Locker Name",
							}}
							customColumnTemplates={{
								status: (rowData) => {
									return (
										<Badge
											className={`flex justify-center  text-secondary-purpleGray items-center ${
												rowData.status === "Verified"
													? "bg-green-400"
													: rowData.status === "Rejected"
													? "bg-red-400"
													: rowData.status === "Pending Verification"
													? "bg-orange-400"
													: rowData.status === "Not Verified"
													? "bg-gray-400"
													: "info"
											} p-2 rounded`}
											value={rowData.status}
										></Badge>
									);
								},
							}}
						/>
					</>
				)}
				{broadCastUsers.length > 0 && (
					<div>
						<div className="grid grid-cols-5 mt-4 pb-4">
							<Button
								value={"SEND SMS"}
								disabled={
									accessPermission.broadcastUser === 1 ||
									accessPermission.broadcastUser === "1"
								}
								className={"w-40 h-8 mb-2"}
								onClick={() => {
									setSendSMSData((prev) => ({
										...prev,
										open: true,
										target: mobileNumbers,
									}));
								}}
							/>
							<Button
								value={"SEND APP MSG"}
								disabled={
									accessPermission.broadcastUser === 1 ||
									accessPermission.broadcastUser === "1"
								}
								className={"w-40 h-8 mb-2"}
								onClick={() => {
									setSendAppData((prev) => ({
										...prev,
										open: true,
										target: targetApp,
									}));
								}}
							/>
							<Button
								value={"SEND EMAIL"}
								disabled={
									accessPermission.broadcastUser === 1 ||
									accessPermission.broadcastUser === "1"
								}
								className={"w-40 h-8 mb-2"}
								onClick={() => {
									setSendEmailData((prev) => ({
										...prev,
										open: true,
										target: emailsList,
									}));
								}}
							/>
						</div>
					</div>
				)}
				{noResultSearch ? (
					<div>
						<NoDataFoundTemplate width={56} height={56} />
					</div>
				) : (
					""
				)}
			</div>
			<SendSMSModal
				header={`SMS Message Notification`}
				open={sendSMSData.open}
				data={sendSMSData}
				onChange={(e) => {
					const { name, value } = e.target;
					setSendSMSData((prev) => ({ ...prev, [name]: value }));
				}}
				onSubmit={() => {
					broadCastUsersAPI
						.sendSms({
							message: sendSMSData.message,
							operatorId: operatorId,
							target: mobileNumbers,
						})
						.then((r) => {
							console.log(r);
							setisLoading(false);
							setSendSMSData({
								open: false,
								message: "",
								operatorId: operatorId,
								target: [],
							});
							// setValidation({
							// 	icon: `${ process.env.PUBLIC_URL } /assets/images / error.png`,
							// 	title: "Invalid data",
							// 	message: "",
							// 	open: false,
							// })
						});
				}}
				onClose={() => {
					setValidation({
						icon: `${process.env.PUBLIC_URL} /assets/images / warning.png`,
						title: "Discard Message?",
						message: "Closing the pop up will discard all the changes you made",
						open: true,
						actions: (
							<div className="gap-2 w-full mx-auto flex flex-row">
								<Button
									onClick={() => setValidation({ open: false })}
									value={"GO BACK"}
									className={"p-2 w-full"}
								/>
								<Button
									onClick={() => {
										setValidation({ open: false });
										setSendSMSData({
											open: false,
											message: "",
											operatorId: operatorId,
											target: [],
										});
									}}
									value={"DISCARD"}
									className={"p-2 w-full"}
								/>
							</div>
						),
					});
				}}
			/>
			<SendAppModal
				header={`App Message Notification`}
				open={sendAppData.open}
				data={sendAppData}
				onChange={(e) => {
					const { name, value } = e.target;
					setSendAppData((prev) => ({ ...prev, [name]: value }));
				}}
				onSubmit={() => {
					broadCastUsersAPI
						.appMessage({
							operatorId: operatorId,
							message: sendAppData.message,
							target: targetApp,
							category: sendAppData.category,
							image: sendAppData.image,
							subject: sendAppData.subject,
						})
						.then((r) => {
							console.log(r);
							setisLoading(false);
							setSendAppData({
								open: false,
								operatorId: operatorId,
								message: "",
								target: [],
								category: -1,
								image: "",
								subject: "",
							});
							// setValidation({
							// 	icon: `${ process.env.PUBLIC_URL } /assets/images / error.png`,
							// 	title: "Invalid data",
							// 	message: "",
							// 	open: false,
							// })
						});
				}}
				onClose={() => {
					setValidation({
						icon: `${process.env.PUBLIC_URL} /assets/images / warning.png`,
						title: "Discard Message?",
						message: "Closing the pop up will discard all the changes you made",
						open: true,
						actions: (
							<div className="gap-2 w-full mx-auto flex flex-row">
								<Button
									onClick={() => setValidation({ open: false })}
									value={"GO BACK"}
									className={"p-2 w-full"}
								/>
								<Button
									onClick={() => {
										setValidation({ open: false });
										setSendAppData({
											open: false,
											operatorId: operatorId,
											message: "",
											target: [],
											category: -1,
											image: "",
											subject: "",
										});
									}}
									value={"DISCARD"}
									className={"p-2 w-full"}
								/>
							</div>
						),
					});
				}}
			/>
			<SendEmailModal
				header={`Email Message Notification`}
				open={sendEmailData.open}
				data={sendEmailData}
				onChange={(e) => {
					const { name, value } = e.target;
					setSendEmailData((prev) => ({ ...prev, [name]: value }));
				}}
				onSubmit={() => {
					broadCastUsersAPI
						.sendEmail({
							message: sendEmailData.message,
							subject: sendEmailData.subject,
							operatorId: operatorId,
							target: emailsList,
						})
						.then((e) => {
							setSendEmailData({
								open: false,
								operatorId: operatorId,
								message: "",
								target: [],
								subject: "",
							});
							// setValidation({
							// 	icon: `${ process.env.PUBLIC_URL } /assets/images / error.png`,
							// 	title: "Invalid data",
							// 	message: "",
							// 	open: false,
							// })
						});
				}}
				onClose={() => {
					setValidation({
						icon: `${process.env.PUBLIC_URL} /assets/images / warning.png`,
						title: "Discard Message?",
						message: "Closing the pop up will discard all the changes you made",
						open: true,
						actions: (
							<div className="gap-2 w-full mx-auto flex flex-row">
								<Button
									onClick={() => setValidation({ open: false })}
									value={"GO BACK"}
									className={"p-2 w-full"}
								/>
								<Button
									onClick={() => {
										setValidation({ open: false });
										setSendEmailData({
											open: false,
											operatorId: operatorId,
											message: "",
											target: [],
											subject: "",
										});
									}}
									value={"DISCARD"}
									className={"p-2 w-full"}
								/>
							</div>
						),
					});
				}}
			/>
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</ContentContainer>
	);
};

export default BroadcastUsers;

function formatDate(inputDate) {
	if (inputDate == null) {
		return "";
	}
	const date = new Date(inputDate);
	const options = {
		year: "numeric",
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		hour12: true,
	};
	return date.toLocaleDateString(undefined, options);
}

function formatBirthdate(inputDate) {
	if (inputDate == null) {
		return "";
	}
	const date = new Date(inputDate);
	const options = {
		year: "numeric",
		month: "short",
		day: "numeric",
		// hour: "2-digit",
		// minute: "2-digit",
		// hour12: true,
	};
	return date.toLocaleDateString(undefined, options);
}
